export interface CourseProgressStatusChip {
  label: string;
  iconClass?: string;
  statusClass: string;
}

export interface CourseProgressStatusDefinition {
  ProgressStatusName?: string;
  ProgressStatusCssClass?: string;
}

export function createCourseProgressStatusChip(
  status: CourseProgressStatusDefinition
): CourseProgressStatusChip | null {
  if (!status?.ProgressStatusName) {
    return null;
  }

  const cssClass = status.ProgressStatusCssClass || 'progress-status--not-started';
  const statusClass = getCardStatusClass(cssClass);
  const iconClass = getStatusIconClass(cssClass);

  return {
    label: status.ProgressStatusName,
    iconClass,
    statusClass: `${statusClass} ${cssClass}`
  };
}

function getCardStatusClass(cssClass: string): string {
  switch (cssClass) {
    case 'progress-status--in-progress':
      return 'course-progress-chip--info';
    case 'progress-status--complete':
    case 'progress-status--acs-passed':
      return 'course-progress-chip--success';
    case 'progress-status--endorsed-waiting-acs':
      return 'course-progress-chip--warning';
    case 'progress-status--acs-failed':
      return 'course-progress-chip--danger';
    default:
      return 'course-progress-chip--muted';
  }
}

function getStatusIconClass(cssClass: string): string | undefined {
  switch (cssClass) {
    case 'progress-status--complete':
      return 'fa fa-check';
    case 'progress-status--endorsed-waiting-acs':
      return 'fa fa-clock-o';
    case 'progress-status--acs-failed':
      return 'fa fa-times-circle';
    case 'progress-status--acs-passed':
      return 'fa fa-check-circle';
    default:
      return undefined;
  }
}
